module.exports = __webpack_public_path__ + "assets/img/play.8b629d8b.png";